export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';

export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_CURRENT_TERMS_REQUEST = 'GET_CURRENT_TERMS_REQUEST';

export const GET_CURRENT_PRIVACY_REQUEST = 'GET_CURRENT_PRIVACY_REQUEST';

export const GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE';

export const UPDATE_USER_PROFILE_REQUEST = 'UPDATE_USER_INFO_REQUEST';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_INFO_SUCCESS';
export const UPDATE_USER_PROFILE_FAILURE = 'UPDATE_USER_INFO_FAILURE';

export const SET_CHAT_TOKEN = 'SET_CHAT_TOKEN';

export const FETCH_BANK_ACCOUNT_SUCCESS = 'FETCH_BANK_ACCOUNT_SUCCESS';
export const ADD_BANK_ACCOUNT_SUCCESS = 'ADD_BANK_ACCOUNT_SUCCESS';
export const DELETE_BANK_ACCOUNT_SUCCESS = 'DELETE_BANK_ACCOUNT_SUCCESS';

export const FETCH_CREDIT_CARDS_REQUEST = 'FETCH_CREDIT_CARDS_REQUEST';
export const FETCH_CREDIT_CARDS_SUCCESS = 'FETCH_CREDIT_CARDS_SUCCESS';
export const FETCH_CREDIT_CARDS_FAILURE = 'FETCH_CREDIT_CARDS_FAILURE';

export const FETCH_COUNTRY_LIST_REQUEST = 'FETCH_COUNTRY_LIST_REQUEST';
export const FETCH_COUNTRY_LIST_SUCCESS = 'FETCH_COUNTRY_LIST_SUCCESS'

export const FETCH_STATE_LIST_REQUEST = 'FETCH_STATE_LIST_REQUEST';
export const FETCH_STATE_LIST_SUCCESS = 'FETCH_STATE_LIST_SUCCESS'

export const ADD_CREDIT_CARD_SUCCESS = 'ADD_CREDIT_CARD_SUCCESS';
export const DELETE_CREDIT_CARD_SUCCESS = 'DELETE_CREDIT_CARD_SUCCESS';
export const DEFAULT_CREDIT_CARD_CHANGE_SUCCESS = 'DEFAULT_CREDIT_CARD_CHANGE_SUCCESS';

// export const ADD_BANK_ACCOUNT_SUCCESS = 'ADD_BANK_ACCOUNT_SUCCESS';
// export const DELETE_BANK_ACCOUNT_SUCCESSS = 'DELETE_BANK_ACCOUNT_SUCCESSS';
// export const DEFAULT_CREDIT_CARD_CHANGE_SUCCESS = 'DEFAULT_CREDIT_CARD_CHANGE_SUCCESS';


export const TOGGLE_SUBSCRIBE_USER_SUCCESS = 'TOGGLE_SUBSCRIBE_USER_SUCCESS';
export const FETCH_NOTIFICATION_COUNT = 'FETCH_NOTIFICATION_COUNT';
